import { memo } from 'react'
import { observer } from 'mobx-react'
import SSL from 'components/Footer/SSL'
import Divider from 'components/Footer/Divider'
import Benefits from 'components/Footer/Benefits'
import { getFooterSeals } from 'components/Footer/getSeals'
import Seals from 'components/Footer/Seals'
import DDFTrustCards from 'containers/Smava/DDFTrustCards'
import VersionDisplay from 'components/VersionDisplay'
import { isTenantSmava } from 'utils/url'
import { isRceEditConfig } from 'config/utils/config'
import { appEnvironment } from 'utils/env'
import { RCE_EDIT_PAGE_NAMES } from 'utils/pages'
import { LoadedConfig } from 'config/config.interface'

interface FooterManagerProps {
  isNotAffiliate: boolean
  currentPageInSession?: string
  config: LoadedConfig
}

const FooterManager = memo(
  observer(
    ({ isNotAffiliate, currentPageInSession, config }: FooterManagerProps) => {
      const isSmava = isTenantSmava()
      const isRCEEditPage = isRceEditConfig(config.name)

      const areDDFTrustCardsDisplayed =
        isSmava &&
        currentPageInSession !== 'dac' &&
        !RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

      return (
        <>
          {!isSmava && !isRCEEditPage && (
            <>
              <SSL />
              <Divider />
              <Benefits />
              <Divider />
              <Seals seals={getFooterSeals(!isNotAffiliate)} itemMargin={16} />
            </>
          )}

          {areDDFTrustCardsDisplayed && (
            <DDFTrustCards isNotAffiliate={isNotAffiliate} />
          )}

          {config.rateHint && <config.rateHint />}
          {appEnvironment !== 'production' && <Divider />}
          <VersionDisplay />
        </>
      )
    }
  )
)

FooterManager.displayName = 'FooterManager'

export default FooterManager
